/* ============================================================
   PDP  –  pdp-accessories.js: the accessory ranges (gardin).

   Loaded before pdp.js by pdp-product-template.liquid when the section
   has an upsell_products block, and called by pdp.js's init().
   ============================================================ */

(function () {
  'use strict';

  var PDP = window.HastaPDP = window.HastaPDP || {};
  /* ---------- accessory ranges: pills + show more ---------------
     One pill per range, one panel each, and a foot that reveals the rows
     the block keeps back. Replaces the carousel, whose arrows hid both the
     ranges and how much was behind them.

     Every row is already in the page - the pills and the foot only flip
     `hidden` - so switching range costs no request. On gardin the block
     sits under the buy button, so a switch moves nothing that matters.

     Rails (Style "Step", the panels wrapped in .rd-up-paneler): the block
     is as tall as the selected range, with the buy button and the help row
     right under it, and a switch glides what is under it to its new place
     instead of jumping: the wrapper's height is pinned at the old value and
     let go to the new one (pdp.css .is-glider). A height cannot animate from
     `auto`, hence the pin first. With reduced motion it is instant.    */
  function upsell(root) {
    var block = root.querySelector('[data-pdp-upsell]');
    if (!block) return;

    var pills = Array.prototype.slice.call(block.querySelectorAll('[data-pdp-upsell-pill]'));
    var wrap = block.querySelector('.rd-up-paneler');
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    var glideEnd = null;

    function glide(from) {
      // let go of a glide still running, so the new range is measured at
      // its natural height and not under the old pin
      if (glideEnd) glideEnd();
      var to = wrap.getBoundingClientRect().height;
      if ((still && still.matches) || Math.abs(to - from) < 1) return;
      var timer;
      var end = function (e) {
        if (e && (e.target !== wrap || e.propertyName !== 'height')) return;
        wrap.removeEventListener('transitionend', end);
        clearTimeout(timer);
        wrap.classList.remove('is-glider');
        wrap.style.height = '';
        glideEnd = null;
      };
      wrap.style.height = from + 'px';
      wrap.getBoundingClientRect();
      wrap.classList.add('is-glider');
      wrap.style.height = to + 'px';
      wrap.addEventListener('transitionend', end);
      // transitionend never fires if the tab is in the background
      timer = setTimeout(end, 400);
      glideEnd = end;
    }

    function select(pill) {
      // mid-glide this is the height on screen, so a second switch goes on
      // from there
      var from = wrap ? wrap.getBoundingClientRect().height : 0;
      pills.forEach(function (p) {
        var on = p === pill;
        p.classList.toggle('is-aktiv', on);
        p.setAttribute('aria-selected', on ? 'true' : 'false');
        // roving tabindex: the selected pill is the one in the tab order
        p.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(p.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (wrap) glide(from);
    }

    /* Rails: the ranges not shown are display:none and their thumbnails
       loading="lazy", so they would be fetched only when a pill opens them -
       a blank square for a moment on a slow phone. Once the page has loaded
       they are asked for, as the old layout did (its hidden panels were laid
       out). The rows behind "Visa mer" stay lazy, as they always were.   */
    function warm() {
      wrap.querySelectorAll('.rd-up-panel[hidden] img[loading="lazy"]').forEach(function (img) {
        if (!img.closest('[data-upsell-extra]')) img.loading = 'eager';
      });
    }
    if (wrap) {
      if (document.readyState === 'complete') setTimeout(warm, 0);
      else window.addEventListener('load', warm, { once: true });
    }

    pills.forEach(function (pill, i) {
      pill.addEventListener('click', function () { select(pill); });

      // arrow / home / end move between ranges - what a screen reader expects
      // of a tablist, and the other half of the roving tabindex above
      pill.addEventListener('keydown', function (e) {
        var to = null;
        if (e.key === 'ArrowRight') to = (i + 1) % pills.length;
        else if (e.key === 'ArrowLeft') to = (i - 1 + pills.length) % pills.length;
        else if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = pills.length - 1;
        if (to === null) return;
        e.preventDefault();
        select(pills[to]);
        pills[to].focus();
      });
    });

    block.querySelectorAll('[data-pdp-upsell-more]').forEach(function (btn) {
      var panel = btn.closest('.rd-up-panel');
      if (!panel) return;
      var extras = Array.prototype.slice.call(panel.querySelectorAll('[data-upsell-extra]'));
      var label = btn.querySelector('.rd-up-mer-text');

      btn.addEventListener('click', function () {
        // a range still gliding in is let go first, or its pin would clip
        // the rows this shows until the glide ends
        if (glideEnd) glideEnd();
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        extras.forEach(function (row) { row.hidden = open; });
        if (label) {
          label.textContent = open ? btn.dataset.labelMore : btn.dataset.labelLess;
        }
      });
    });

    quickAdd(root);
  }

  /* ---------- freight class -------------------------------------
     The class the product's own page sends with it (the checkout prices
     freight on _Oversized_Goods / _Long_Goods): the theme's rule
     (window.HastaShipping.calculate, component-customizer.js, loaded by the
     layout) fed the Bredd option, else the title - see
     assets/pairing-drawer.js freightClass, the same for the drawer. Read
     from the button (snippets/pdp-upsell-card). */
  function freightProperties(btn) {
    var d = btn.dataset;
    if (d.freight !== 'true') return {};
    function calc(value) {
      if (value === undefined || value === '') return null;
      var rule = window.HastaShipping;
      if (rule && typeof rule.calculate === 'function') return rule.calculate(true, value);
      var match = String(value).replace(',', '.').match(/\d+(?:\.\d+)?/);
      var size = match ? parseFloat(match[0]) : 0;
      if (!(size >= 110)) return null;
      return size <= 260 ? 'Oversized_Goods' : 'Long_Goods';
    }
    var cls = calc(d.freightWidth) || calc(d.freightTitle);
    var props = {};
    if (cls) props['_' + cls] = 'Yes';
    return props;
  }

  /* ---------- quick add ----------------------------------------
     The prototype's button had no handler. This adds the item,
     acknowledges on the button and bumps the header cart count.  */
  function quickAdd(root) {
    root.querySelectorAll('[data-pdp-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.dataset.variantId;
        if (!id || btn.classList.contains('is-tillagd')) return;

        btn.disabled = true;
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: freightProperties(btn) }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart');
            return r.json();
          })
          .then(function () {
            btn.classList.add('is-tillagd');
            bumpBlip();
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            setTimeout(function () {
              btn.classList.remove('is-tillagd');
              btn.disabled = false;
            }, 1600);
          })
          .catch(function () {
            btn.disabled = false;
          });
      });
    });
  }

  function bumpBlip() {
    var blip = document.querySelector('.cart-blip');
    if (!blip) return;
    var count = parseInt(blip.textContent, 10);
    blip.textContent = isNaN(count) ? '1' : String(count + 1);
    blip.hidden = false;
    var sr = document.querySelector('[data-cart-count-sr]');
    if (sr) sr.textContent = blip.textContent;
  }

  PDP.accessories = upsell;
})();
